/* eslint-disable max-len */
import React from 'react';
import {detectOrderDates} from '../../utils/commonUtils';

const SelectedCard = ({data, labels, updateMyData}) => {
  return (
    <>
      {
        data.map((line, indexi) => {
          const {
            movementScheduledDate,
            movementCloseDate,
            hunterScheduledDate,
            hunterCloseDate,
            accessoriesScheduledDate,
            accessoriesOpenDate,
            accessoriesCloseDate,
            pdsScheduledDate,
            pdsOpenDate,
            pdsCloseDate,
          } = line;
          const [movValue, movColor] = detectOrderDates(movementScheduledDate, null, movementCloseDate);
          const [huntValue, hunyColor] = detectOrderDates(hunterScheduledDate, null, hunterCloseDate);
          const [accValue, accColor] = detectOrderDates(accessoriesScheduledDate, accessoriesOpenDate, accessoriesCloseDate);
          const [pdsValue, pdsColor] = detectOrderDates(pdsScheduledDate, pdsOpenDate, pdsCloseDate);
          return (
            <div key={indexi} className='priorization-selected-card-container'>
              <table cellPadding="0" cellSpacing="0" className='priorization-selected-card-table'>
                <tbody>
                  {
                    Object.entries(labels).map((entry, indexj) => {
                      const [key, label] = entry;
                      if (indexj === 0) {
                        return (
                          <tr key={indexj}>
                            <td className='priorization-selected-card-label'>{label} :</td>
                            <td>
                              <div className='priorization-selected-card-first-item'>
                                <span className='priorization-selected-card-value'> {line[key]}</span>
                                <div
                                  className='priorization-selected-card-delete pointer'
                                  onClick={() => updateMyData(line.index, 'isSelected', false)}
                                >
                                  &times;
                                </div>
                              </div>
                            </td>
                          </tr>
                        );
                      }
                      return (
                        
                        <tr>
                          <td className='priorization-selected-card-label no-spaces'><span>{label} :</span></td>
                          <td><span className='priorization-selected-card-value'> {line[key]}</span></td>
                        </tr>
                      );
                    }
                    )
                  }
                </tbody>
              </table>
              <div className='priorizations-modal-dates-container'>
                <div className={`priorizations-modal-date-chip ${movColor}`}>
                  MOV.: {movValue}
                </div>
                <div className={`priorizations-modal-date-chip ${hunyColor}`}>
                  HUNTER: {huntValue}
                </div>
                <div className={`priorizations-modal-date-chip ${accColor}`}>
                  ACC.: {accValue}
                </div>
                <div className={`priorizations-modal-date-chip ${pdsColor}`}>
                  PDS.: {pdsValue}
                </div>
              </div>
            </div>
          );
        }
        )
      }
    </>
  );
};

export default SelectedCard;
